import React, { useContext, useEffect, useMemo, useState } from 'react';
import { LanguageContext } from '@/common/contexts/LanguageContext';
import OnePagePayuPayment from './components/payu/OnePagePayuPayment';
import {
	STRIPE_ONE_OFF,
	STRIPE_SUBSCRIBTION,
	FAST_SPRING_ONE_OFF,
} from '../checkout/Checkout';
import OnePageStripeSubscribtionPayment from './components/stripe/OnePageStripeSubscribtionPayment';
import OnePageStripeOneTimePayment from './components/stripe/OnePageStripeOneTimePayment';
import useQueryMemo from '@/common/hooks/urlMemo';
import OneOffFastSpringPaymentWrapper from '../../../pages/checkouts/promoCheckout/components/fastSpring/one-off-v2/OneOffFastSpringPaymentV2';
import { CheckoutContext } from '../../../common/contexts/checkoutContext';

export const PAYU_OPERATOR_COUNTRIES = ['pl'];

const PromoCheckout = () => {
	const { lang } = useContext(LanguageContext);
	const queryMemo = useQueryMemo();
	const [quizVersion, setQuizVersion] = useState();
	const [spVersion, setSpVersion] = useState();

	const paymentPage = useMemo(() => {
		if (PAYU_OPERATOR_COUNTRIES.includes(lang)) {
			return <OnePagePayuPayment />;
		}

		if (STRIPE_SUBSCRIBTION.includes(lang)) {
			return <OnePageStripeSubscribtionPayment />;
		}

		if (STRIPE_ONE_OFF.includes(lang)) {
			return <OnePageStripeOneTimePayment />;
		}

		if (FAST_SPRING_ONE_OFF.includes(lang)) {
			return <OneOffFastSpringPaymentWrapper />;
		}

		return <></>;
	}, [lang]);

	useEffect(() => {
		const originVariant = queryMemo.get('origin_variant');
		localStorage.setItem('origin_variant', originVariant);
	}, []);

	return <>{paymentPage}</>;
};

export default PromoCheckout;
